/**
 * product-tabs.js
 * Handles tab switching with directional slide animation.
 *
 * Direction logic:
 *   Clicked tab is LEFT  of current → old exits RIGHT, new enters from LEFT
 *   Clicked tab is RIGHT of current → old exits LEFT,  new enters from RIGHT
 *
 * Safe to include multiple times on a page — each section is scoped
 * to its own [data-section-id] root.
 */

(function () {
  function initProductTabs(section) {
    const tabs   = Array.from(section.querySelectorAll('.product-tabs__tab'));
    const panels = Array.from(section.querySelectorAll('.product-tabs__panel'));
    const wrap   = section.querySelector('[data-panels-wrap]');

    let activeIndex = 0;
    let animating   = false;


    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const nextIndex = parseInt(tab.dataset.tab, 10);
        if (nextIndex === activeIndex || animating) return;

        animating = true;

        const goingLeft = nextIndex < activeIndex;

        const outClass = goingLeft ? 'pt-out-right'     : 'pt-out-left';
        const inClass  = goingLeft ? 'pt-in-from-left'  : 'pt-in-from-right';

        const outPanel = panels[activeIndex];
        const inPanel  = panels[nextIndex];

        // Lock wrapper height so it doesn't collapse while outgoing is position:absolute
        wrap.style.minHeight = outPanel.offsetHeight + 'px';

        // Float outgoing panel above the wrapper
        outPanel.classList.add('pt-leaving', outClass);

        // On mobile, pre-position the incoming panel off-screen before
        // revealing it — mobile browsers can render one frame at translateX(0)
        // before the animation class fires, causing a visible jump.
        // Desktop handles this correctly without the extra reflow.
        if (window.matchMedia('(max-width: 749px)').matches) {
          // Keep the inline transform in place while adding the animation class —
          // the animation overrides it, so the panel stays off-screen until the
          // first animation frame fires. Clearing it before classList.add was the
          // bug: that left a window where the panel sat at translateX(0) with no
          // animation running, causing the visible jump.
          inPanel.style.transform = 'translateX(' + (goingLeft ? '-100%' : '100%') + ')';
          inPanel.removeAttribute('hidden');
          void inPanel.offsetWidth; // commit off-screen position to layout engine
        } else {
          inPanel.removeAttribute('hidden');
        }
        inPanel.classList.add(inClass);

        // Update tab active states immediately
        tabs[activeIndex].classList.remove('product-tabs__tab--active');
        tabs[activeIndex].setAttribute('aria-selected', 'false');
        tab.classList.add('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        // Cleanup once the incoming panel's own animation finishes. Ignore
        // bubbled animationend events from product cards inside the panel.
        let cleanupTimer;
        const finish = function (event) {
          if (event && event.target !== inPanel) return;
          clearTimeout(cleanupTimer);
          inPanel.removeEventListener('animationend', finish);
          inPanel.removeEventListener('animationcancel', finish);

          // Clean up outgoing
          outPanel.classList.remove('pt-leaving', outClass);
          outPanel.classList.remove('product-tabs__panel--active');
          outPanel.setAttribute('hidden', '');

          // Clean up incoming (also clear any mobile inline transform)
          inPanel.style.transform = '';
          inPanel.classList.remove(inClass);
          inPanel.classList.add('product-tabs__panel--active');

          // Release height lock
          wrap.style.minHeight = '';

          activeIndex = nextIndex;
          animating   = false;
        };

        inPanel.addEventListener('animationend', finish);
        inPanel.addEventListener('animationcancel', finish);
        cleanupTimer = setTimeout(finish, 500);
      });
    });
  }

  // Init all product-tabs sections on the page
  document.querySelectorAll('.product-tabs[data-section-id]').forEach(initProductTabs);
})();
